import {
  CALENDAR_SET_DATE,
  CALENDAR_SET_ADD_DATE,
  CALENDAR_SET_DATA,
  CALENDAR_SET_MUTATING,
  CALENDAR_FETCH_EVENTS_REQUEST,
  CALENDAR_FETCH_EVENTS_SUCCESS,
  CALENDAR_SET_FATAL_ERROR,
  CALENDAR_SET_STATE,
  CALENDAR_SET_SERVICES,
  CALENDAR_SET_SERVICE_CATEGORIES,
  CALENDAR_SET_SERVICE_PRODUCT_BUNDLES,
  CALENDAR_SET_EVENT_TYPES,
} from '../actions/calendar';

export default function calendarReducer(
  state: any = {
    date: undefined,
  },
  action: any
) {
  switch (action.type) {
    case CALENDAR_SET_DATE:
      return { ...state, date: action.date.format('YYYY-MM') };
    case CALENDAR_SET_ADD_DATE:
      return { ...state, addDate: action.addDate };
    case CALENDAR_SET_DATA:
      return { ...state, data: action.data };
    case CALENDAR_SET_MUTATING:
      return { ...state, mutating: action.mutating };
    case CALENDAR_FETCH_EVENTS_REQUEST:
      return { ...state, fetching: true };
    case CALENDAR_FETCH_EVENTS_SUCCESS:
      return { ...state, fetching: false, events: action.data };
    case CALENDAR_SET_FATAL_ERROR:
      return { ...state, fetching: false, error: action.error };

    case CALENDAR_SET_STATE:
      return { ...state, state: action.state };

    case CALENDAR_SET_SERVICES:
      return { ...state, services: action.services };
    case CALENDAR_SET_SERVICE_CATEGORIES:
      return { ...state, serviceCategories: action.serviceCategories };
    case CALENDAR_SET_SERVICE_PRODUCT_BUNDLES:
      return { ...state, serviceProductBundles: action.serviceProductBundles };
    case CALENDAR_SET_EVENT_TYPES:
      return { ...state, eventTypes: action.eventTypes };

    default:
      return state;
  }
}
